import { useEffect, useState } from 'react'
import {
    getRecProducts
} from '../../../../../../../../api'

export default () => {
    const [loading, setLoading] = useState(false)
    const [recs, setRecs] = useState(null)
    useEffect(async () => {
        setLoading(true)
        const response = await getRecProducts(21)
        if(response?.code === 200){
            const result = response?.result?.map(rec => {
                return {...rec, products: rec.products?.map(p => ({
                    ...p,
                    geekoRequsestId: response.requestId,
                    geekoExperimentId: response.experimentId,
                    layerName: response.layerName,
                    trackingRecords: response.trackingRecords
                }))}
            })
            setRecs(result)
            //test
            // setRecs([
            //     {
            //         name: 'Bottoms',
            //         products: response?.result?.[0]?.products
            //     },
            //     {
            //         name: 'Dresses',
            //         products: response?.result?.[0]?.products
            //     },
            //     {
            //         name: 'Lingrie',
            //         products: response?.result?.[0]?.products
            //     }
            // ])
        }
        setLoading(false)
    }, [])

    return {
        loading,
        recs
    }
}